import { useMemo } from 'react';

import type { IdLabelDto, LabelDto, LabelType } from '@/services/ws-labels/src/main/resources/rest-api';
import { getLabels } from '@/services/ws-labels/src/main/resources/rest-api';
import { useSubscribe } from '@/js/libs/observable';
import { useRequest } from '@/js/libs/use-request';

import { ErrorCode, type Option } from 'src/types';
type UseLabelsOptionsReturn = {
  options: Option<IdLabelDto>[];
  labelsMap: Record<string, LabelDto>;
  pending: boolean;
};
export const useLabelsOptions = (type: LabelType): UseLabelsOptionsReturn => {
  const request = useRequest({
    apiMethod: getLabels,
    params: { type },
    ignoreErrors: [ErrorCode.NotFound],
  });
  const { options, labelsMap } = useSubscribe(request.data$, (response) => {
    const items = response?.data.items ?? [];
    return {
      options: items.map((label) => ({ label: label.name, value: label.id })),
      labelsMap: items.reduce<Record<string, LabelDto>>((acc, label) => {
        acc[label.id.toString()] = label;
        return acc;
      }, {}),
    };
  });
  const pending = useSubscribe(request.pending$);
  return useMemo(() => ({ options, labelsMap, pending }), [options, labelsMap, pending]);
};
